
export abstract class SmartTableDataGroup {
  abstract getData(): any[];
}
